/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../kubb/client";
import type { Client, RequestConfig, ResponseErrorConfig, ResponseConfig } from "../../../kubb/client";
import type { GetLeadByExternalIdDocumentsQueryResponse, GetLeadByExternalIdDocumentsPathParams, GetLeadByExternalIdDocuments401, GetLeadByExternalIdDocuments403, GetLeadByExternalIdDocuments404, GetLeadByExternalIdDocuments503 } from "../models/GetLeadByExternalIdDocuments";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getLeadByExternalIdDocumentsQueryKey = ({ externalId }: { externalId: GetLeadByExternalIdDocumentsPathParams["externalId"] }) => [{ url: '/api/v1/contact/leads/by-external-id/:externalId/documents', params: {externalId:externalId} }] as const

export type GetLeadByExternalIdDocumentsQueryKey = ReturnType<typeof getLeadByExternalIdDocumentsQueryKey>

/**
 * @description Returns all documents (license, registration, odometer) on the lead. Looks up by the Lease End external deal ID instead of UUID.
 * @summary List documents for a lead (driver view) (by external ID)
 * {@link /api/v1/contact/leads/by-external-id/:externalId/documents}
 */
export async function getLeadByExternalIdDocuments({ externalId }: { externalId: GetLeadByExternalIdDocumentsPathParams["externalId"] }, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetLeadByExternalIdDocumentsQueryResponse, ResponseErrorConfig<GetLeadByExternalIdDocuments401 | GetLeadByExternalIdDocuments403 | GetLeadByExternalIdDocuments404 | GetLeadByExternalIdDocuments503>, unknown>({ method : "GET", url : `/api/v1/contact/leads/by-external-id/${externalId}/documents`, ... requestConfig })
  return res
}

export function getLeadByExternalIdDocumentsQueryOptions({ externalId }: { externalId: GetLeadByExternalIdDocumentsPathParams["externalId"] }, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getLeadByExternalIdDocumentsQueryKey({ externalId })
        return queryOptions<ResponseConfig<GetLeadByExternalIdDocumentsQueryResponse>, ResponseErrorConfig<GetLeadByExternalIdDocuments401 | GetLeadByExternalIdDocuments403 | GetLeadByExternalIdDocuments404 | GetLeadByExternalIdDocuments503>, ResponseConfig<GetLeadByExternalIdDocumentsQueryResponse>, typeof queryKey>({
         enabled: !!(externalId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getLeadByExternalIdDocuments({ externalId: externalId }, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns all documents (license, registration, odometer) on the lead. Looks up by the Lease End external deal ID instead of UUID.
 * @summary List documents for a lead (driver view) (by external ID)
 * {@link /api/v1/contact/leads/by-external-id/:externalId/documents}
 */
export function useGetLeadByExternalIdDocuments<TData = ResponseConfig<GetLeadByExternalIdDocumentsQueryResponse>, TQueryData = ResponseConfig<GetLeadByExternalIdDocumentsQueryResponse>, TQueryKey extends QueryKey = GetLeadByExternalIdDocumentsQueryKey>({ externalId }: { externalId: GetLeadByExternalIdDocumentsPathParams["externalId"] }, options: 
{
  query?: Partial<QueryObserverOptions<ResponseConfig<GetLeadByExternalIdDocumentsQueryResponse>, ResponseErrorConfig<GetLeadByExternalIdDocuments401 | GetLeadByExternalIdDocuments403 | GetLeadByExternalIdDocuments404 | GetLeadByExternalIdDocuments503>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getLeadByExternalIdDocumentsQueryKey({ externalId })
         

         const query = useQuery({
          ...getLeadByExternalIdDocumentsQueryOptions({ externalId }, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetLeadByExternalIdDocuments401 | GetLeadByExternalIdDocuments403 | GetLeadByExternalIdDocuments404 | GetLeadByExternalIdDocuments503>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}